export enum ChartDateRangeTypeCode{
    Month = 0,
    Year = 1
}